import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button.tsx';
import { useTranslation } from 'react-i18next';
import { type OperatorPath, OperatorSelector } from '../../../../StructureAndLogic/components/OperatorSelector.tsx';

type GroupHeaderProps = {
  title: string;
  path?: OperatorPath;
  isEdit?: boolean;
  isSubgroup?: boolean;
  isRemoveDisabled?: boolean;
  isExpanded: boolean;
  onRemove: () => void;
  onExpandToggle: () => void;
  operatorSelectorReadOnly?: boolean;
  operatorAndDisabled?: boolean;
};

export const GroupHeader = ({
  title,
  isEdit = false,
  isRemoveDisabled = true,
  isSubgroup = false,
  path,
  isExpanded,
  onRemove,
  onExpandToggle,
  operatorSelectorReadOnly = false,
  operatorAndDisabled = false,
}: GroupHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        p: 3,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack
        direction="row"
        sx={{
          gap: 4,
          alignItems: 'center',
        }}
      >
        <Typography data-test="group-title" variant="h3">
          {title}
        </Typography>
        {isSubgroup && path && (
          <OperatorSelector
            isSubgroup
            path={path}
            readOnly={operatorSelectorReadOnly}
            andOperatorDisabled={operatorAndDisabled}
          />
        )}
      </Stack>
      <Stack
        direction="row"
        sx={{
          gap: 1,
        }}
      >
        {isEdit && (
          <Button
            color="error"
            data-test="remove-group-button"
            disabled={isRemoveDisabled}
            onClick={onRemove}
            variant="text"
            component="span"
          >
            {t('Remove Group')}
          </Button>
        )}
        <ListItemButton onClick={onExpandToggle} sx={{ padding: 0 }}>
          <ListItemIcon sx={{ minWidth: 'unset' }}>
            {isExpanded ? <ExpandLess data-test="expand-less-icon" /> : <ExpandMore data-test="expand-more-icon" />}
          </ListItemIcon>
        </ListItemButton>
      </Stack>
    </Stack>
  );
};
